import { chipsCodec, rememberedSetting, toggleChip } from './clockFilterState';
import { DEPTH_POSITIONS, depthPositionLabel, depthPositionMeaning } from '../depthReading';

// The Cycle Clock's depth filter (DWLF-511): where each market's last close sits in its window's band of past
// cycles' moves (the API's `depth.reading.position`, read with depth=1). The position is the API's; nothing here
// re-reads the band. A market whose window carries no reading (no band, a withheld one, an API without it) is
// "No depth data", never dropped.
// The positions come from depthReading's one vocabulary, so a position added there appears here. Shown with
// IN ZONE first and Not reached last (nothing in the band applies yet); the rest in the vocabulary's order.
const ORDER = [
  'in-zone',
  ...DEPTH_POSITIONS.filter((p) => p !== 'in-zone' && p !== 'not-reached'),
  'not-reached',
].filter((p) => DEPTH_POSITIONS.includes(p));
export const NO_DEPTH = 'none';

// Multi-select (DWLF-548): any combination of positions, none ticked = All.
export const DEPTH_FILTERS = [
  ...ORDER.map((id) => ({ id, label: depthPositionLabel(id), title: depthPositionMeaning(id) })),
  { id: NO_DEPTH, label: 'No depth data', title: 'no depth reading for this window' },
];

const IDS = DEPTH_FILTERS.map((f) => f.id);

/** A market's depth bucket: its window's reading position, or `none`. */
export const depthKey = (m) => {
  const position = m?.depth?.reading?.position;
  return ORDER.includes(position) ? position : NO_DEPTH;
};

export const matchesDepth = (ids, m) => !ids.length || ids.includes(depthKey(m));

/** Ticks or unticks one chip, keeping the chips' own order. */
export const toggleDepth = (ids, id) => toggleChip(IDS, ids, id);

/** Markets per option, and `all`, over the markets given (the caller passes those its other filters keep). */
export const depthCounts = (markets) => {
  const counts = Object.fromEntries(IDS.map((id) => [id, 0]));
  markets.forEach((m) => { counts[depthKey(m)] += 1; });
  counts.all = markets.length;
  return counts;
};

// A choice saved while depth was single-select (one bare id) reads as that one chip ticked.
const chips = chipsCodec(IDS);
const remembered = rememberedSetting('cycle-clock-depth', { ...chips, parse: (raw) => (IDS.includes(raw) ? [raw] : chips.parse(raw)) });
export const readDepthFilter = remembered.read;
export const saveDepthFilter = remembered.save;
